// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__AUBUc","cell":"ColumnAccessor_cell__2-XHp","firstCellAccent":"ColumnAccessor_firstCellAccent__3ptim"};